import React from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from "@material-ui/core";
import { AudioControlButton } from "frontend/src/ui/audio-control-button";
import { DeleteButtonWithModal } from "frontend/src/ui/delete-button-with-modal";
import { TrackRow } from "frontend/src/ui/track-row";
import { TableRowsSkeleton } from "frontend/src/ui/table-skeleton";
import { usePlayerTrackId } from "frontend/src/domain/player-track-queue";
import { useIsAudioPlaying } from "frontend/src/domain/audio";
import { pause } from "frontend/src/features/control-audio";
import { useDeleteAdvertisement } from "frontend/src/domain/audio-advertisements/actions";
var Row = function (_a) {
    var id = _a.id, title = _a.title, duration = _a.duration, selected = _a.selected, playing = _a.playing, loading = _a.loading, onPlay = _a.onPlay, onPause = _a.onPause;
    var run = useDeleteAdvertisement().run;
    var remove = function () { return run(id); };
    var play = function () { return onPlay({ selected: selected, id: id }); };
    return (React.createElement(TrackRow, { isSelectedForPlayer: selected },
        React.createElement(TableCell, null,
            React.createElement(AudioControlButton, { isPlaying: playing, isLoading: loading, onPause: onPause, onPlay: play })),
        React.createElement(TableCell, null, title),
        React.createElement(TableCell, null, duration),
        React.createElement(TableCell, { width: "5%" },
            React.createElement(DeleteButtonWithModal, { onDelete: remove, message: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \"" + title + "\"?" }))));
};
var Advertisements = function (_a) {
    var advertisements = _a.advertisements, onTrackPlay = _a.onTrackPlay;
    var playerTrackId = usePlayerTrackId();
    var isAudioPlaying = useIsAudioPlaying();
    return (React.createElement(React.Fragment, null, advertisements === null || advertisements === void 0 ? void 0 : advertisements.map(function (_a) {
        var id = _a.id, title = _a.title, duration = _a.duration;
        var selected = playerTrackId === id;
        var playing = selected && isAudioPlaying;
        var loading = false;
        return (React.createElement(Row, { key: id, id: id, title: title, duration: duration.formatted, selected: selected, playing: playing, loading: loading, onPlay: onTrackPlay, onPause: pause }));
    })));
};
var NothingFound = function () { return (React.createElement(Typography, null, "\u041D\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043E \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0435\u043A\u0430.")); };
export var UserTrackTab = function (_a) {
    var advertisements = _a.advertisements, onTrackPlay = _a.onTrackPlay;
    if ((advertisements === null || advertisements === void 0 ? void 0 : advertisements.length) === 0) {
        return React.createElement(NothingFound, null);
    }
    return (React.createElement(TableContainer, { component: Paper },
        React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { width: "5%" }, null),
                    React.createElement(TableCell, null, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                    React.createElement(TableCell, null, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C"),
                    React.createElement(TableCell, { width: "5%" }, null))),
            React.createElement(TableBody, null, advertisements ? (React.createElement(Advertisements, { advertisements: advertisements, onTrackPlay: onTrackPlay })) : (React.createElement(TableRowsSkeleton, { rows: 5, columns: 4 }))))));
};
